interface IFieldCoordinatorReview {
    reportType?: string;
    injuryType?: string;
    injurySummary?: string;
}

class FieldCoordinatorReview implements IFieldCoordinatorReview {
    public reportType?: string;
    public injuryType?: string;
    public injurySummary?: string;

    constructor(fcr: IFieldCoordinatorReview = {}) {
        this.reportType = fcr.reportType;
        this.injuryType = fcr.injuryType;
        this.injurySummary = fcr.injurySummary;
    }

    public isFieldCoordinatorTabValid(): string[] {
        const validations: string[] = [];
        if (this.reportType === undefined || this.reportType.length === 0) {
            validations.push('reportType');
        }
        if (this.injuryType === undefined || this.injuryType.length === 0) {
            validations.push('injuryType');
        }
        if (this.injurySummary === undefined || this.injurySummary.length === 0) {
            validations.push('injurySummary');
        }
        return validations;
    }
}

export default FieldCoordinatorReview;
export { FieldCoordinatorReview, IFieldCoordinatorReview };
